import { render, staticRenderFns } from "./Main2.vue?vue&type=template&id=c9001b0a"
import script from "./Main2.vue?vue&type=script&lang=js"
export * from "./Main2.vue?vue&type=script&lang=js"
import style0 from "./Main2.vue?vue&type=style&index=0&id=c9001b0a&prod&lang=scss"
import style1 from "./Main2.vue?vue&type=style&index=1&id=c9001b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports